// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__37QND","buttons":"styles_buttons__22p7C"};